import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { DatePicker} from 'element-ui'
import fr from 'element-ui/lib/locale/lang/fr'
import es from 'element-ui/lib/locale/lang/es'
import en from 'element-ui/lib/locale/lang/en'
import el from 'element-ui/lib/locale/lang/el'
import sv from 'element-ui/lib/locale/lang/sv-SE'
import da from 'element-ui/lib/locale/lang/da'
import locale from 'element-ui/lib/locale'

Vue.use(VueI18n);
Vue.use(DatePicker)

const SUPPORTED_LOCALES = ['en', 'fr', 'es', 'el', 'sv', 'da'];
const LOCALE_STORAGE_KEY = 'otc_guest_locale';

const elementLocales = { en, fr, es, el, sv, da };

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([a-z0-9]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function applyElementLocale(code) {
  if (elementLocales[code]) {
    locale.use(elementLocales[code]);
  }
}

function detectBrowserLocale() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return 'en';
  }
  const browserLocale = navigator.language || navigator.userLanguage || '';
  const languageCode = browserLocale.split('-')[0];

  if (SUPPORTED_LOCALES.includes(languageCode)) {
    return languageCode;
  }
  return 'en';
}

function getStoredLocale() {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored)) {
      return stored;
    }
  } catch (e) {
    // localStorage unavailable (private mode, etc.)
  }
  return null;
}

const initialLocale = getStoredLocale() || detectBrowserLocale();
applyElementLocale(initialLocale);

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});

export function setLocale(code, { persist } = {}) {
  if (!SUPPORTED_LOCALES.includes(code)) {
    return;
  }
  i18n.locale = code;
  applyElementLocale(code);
  if (persist) {
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, code);
    } catch (e) {
      // localStorage unavailable
    }
  }
}

export function hasExplicitChoice() {
  return getStoredLocale() !== null;
}

// Resolve the page language once its venue settings are loaded. The guest's
// stored switcher choice is only honored on surfaces where the switcher is
// enabled; with the switcher hidden (e.g. kiosk mode) the venue default rules,
// so a stale stored choice cannot lock a device into the wrong language.
export function applyPageLocale(groupDefault, switcherEnabled) {
  if (switcherEnabled && hasExplicitChoice()) {
    return; // boot already applied the stored choice
  }
  const target = (groupDefault && groupDefault !== 'en' && SUPPORTED_LOCALES.includes(groupDefault))
    ? groupDefault
    : detectBrowserLocale();
  setLocale(target);
}

export default i18n;
